/**
 * Microsoft Entra External ID (MSAL) Configuration
 *
 * Configuration is loaded from backend to avoid hardcoding credentials.
 */

import { INTERPRETER_BASE_URL } from './runtime';

/**
 * Fetch Azure configuration from backend
 * @returns config if successful, undefined otherwise
 */
export async function fetchMsalConfig() {
  let azureConfig = null;

  try {
    const response = await fetch(`${INTERPRETER_BASE_URL}/api/auth/azure-config`);
    if (!response.ok) {
      return undefined
    }

    azureConfig = await response.json();
    console.log('✅ Azure config loaded from backend');
  } catch (error) {
    console.error('❌ Failed to load Azure config:', error);
    return undefined
  }

  return {
    auth: {
      clientId: azureConfig.client_id,
      authority: azureConfig.authority,
      knownAuthorities: [`${azureConfig.tenant_subdomain}.ciamlogin.com`],
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
}

/**
 * Scopes for token requests
 */
/**
 * Get login request with dynamic prompt based on environment state
 * Forces fresh login if this environment has no cached user
 */
export function getLoginRequest() {
  const hasStoredUser = !!localStorage.getItem('user');

  return {
    scopes: ["openid", "profile", "email"],
    // If this environment has no stored user, force fresh login (ignore Azure SSO)
    // If environment has stored user, allow SSO
    prompt: hasStoredUser ? undefined : "login"
  };
}

// For backward compatibility
export const loginRequest = getLoginRequest();
